<template>
    <div class="view auth-view">
        <div class="auth-container">
            <div class="auth-box">
                <div class="logo">
                    <img v-if="isDarkMode" src="./../assets/images/logo-alt.svg">
                    <img v-else src="./../assets/images/logo.svg">
                </div>
                <div class="box-head">
                    <h1 class="title">Enjoy to <span>cloud computing</span></h1>
                    <p class="description">Enter your email and password to sign in</p>
                </div>
                <div class="box-form" @keyup.enter="loginWithEmailAndPassword()">
                    <div class="form-item">
                        <label for="">Email</label>
                        <input type="email" placeholder="Your email address" v-model="userCred.email">
                    </div>
                    <div class="form-item">
                        <label for="">Password</label>
                        <input type="password" placeholder="Your password" v-model="userCred.password">
                    </div>
                    <div class="actions">
                        <button class="btn" @click="loginWithEmailAndPassword()" :class="{'loading': authStatuses.loginInProcess}">
                            <div class="loader line-scale-pulse-out">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                            <span class="btn-text">Sign In</span>
                        </button>
                        <button class="btn" @click="loginWithGoogle()" :class="{'loading': authStatuses.loginInProcess}">
                            <div class="loader line-scale-pulse-out">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                            <span class="btn-icon fab fa-google"></span>
                            <span class="btn-text">Sign in with Google</span>
                        </button>
                    </div>
                    <div class="msg">
                        <p v-if="authStatuses.errorMsg">{{ authStatuses.errorMsg }}</p>
                    </div>
                </div>
                <div class="box-footer">
                    <p class="info">At the moment the service is in the closed beta testing phase, so access to it is very limited. If you are interested in this project and want to join the testing process, visit <a href="https://about.ionds.app" target="_blank">our website</a> and contact us via email</p>
                </div>
            </div>
        </div>
        <div class="auth-banner"></div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            userCred: {
                email: '',
                password: ''
            }
        }
    },
    computed: {
        authStatuses() {
            return this.$store.getters['getAuthStatuses'];
        },
        isDarkMode() {
            return this.$store.getters['isDarkMode'];
        }
    },
    methods: {
        loginWithEmailAndPassword() {
            this.$store.dispatch('loginWithEmailAndPassword', this.userCred);
        },
        loginWithGoogle() {
            this.$store.dispatch('loginWithGoogle');
        }
    }
}
</script>
